export default __webpack_public_path__ + "static/media/loginbg.65a4e7ef.mov";